module.exports = __webpack_public_path__ + "static/media/Invoice-SaaS.46c0f4af.png";